import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4rem 7rem 0 7rem;
  @media only screen and (max-width: 1000px) {
    padding: 1rem 3rem 0 3rem;
  }
`;

export const TextStyle = styled.span`
  letter-spacing: 0.02em;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.4rem;
  opacity: 0.8;
  color: #a4aeb4;
`;

export const LinkTextStyle = styled.span`
  letter-spacing: 0.02em;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #2696e8;
`;

export const Container = styled.div``;
